export enum CardLayouts {
  LEGACY = 'LEGACY',
  DEFAULT = 'DEFAULT',
  BUTTON_ONLY = 'BUTTON_ONLY',
}
